module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="cashbackHotelBanner">\n    <div class="cashbackHotelBanner__container js-banner-width js-rounded">\n        <div class="cashbackHotelBanner__container__logos">\n            <div class="cashbackHotelBanner__container__mir-logo"></div>\n            ×\n            <div class="cashbackHotelBanner__container__rostourism-logo"></div>\n        </div>\n\n        <div class="cashbackHotelBanner__container-label">'+
((__t=(bannerText ))==null?'':__t)+
'</div>\n\n        <div class="cashbackHotelBanner__container-arrow js-arrow-position"></div>\n\n        <a href="'+
((__t=(landingUrl ))==null?'':__t)+
'"\n           class="cashbackHotelBanner__container-link"\n           target="_blank">\n            Узнать больше\n\n            <i class="icon icon-i16_next"></i>\n        </a>\n    </div>\n</div>\n';
}
return __p;
};
